module.exports = __webpack_public_path__ + "img/progress_task.76e7f7c.png";